import { graphql } from "relay-runtime"

const ChatAppointmentConnectionKey = "RootChatAppointmentConnection_chatsTakenByMe"

const chatAppointmentsQuery = graphql`
  query useChatAppointmentsQuery {
    chatsTakenByMe(first: null) @connection(key: "RootChatAppointmentConnection_chatsTakenByMe") {
      edges {
        node {
          ...ChatAppointmentFragment @relay(mask: false)
          ...ChatThreadItemFragment
        }
      }
    }
  }
`
export { chatAppointmentsQuery, ChatAppointmentConnectionKey }
